// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/grid","rootFixed":"grid-m__rootFixed__2GZXD","headerFixed":"grid-m__headerFixed__2X7jF"};